export const environment = {
    production: true,
    baseUrl: 'https://api.bitv5.net/api/',
    authority: 'https://id.bitv5.net',
    appUrl: 'https://bitv5.net/',
    analyticsId: null
};
